import { useState } from "react"
import { P } from "../../components/p/P"
import { BrochureShortcutWrapper } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload } from "@fortawesome/free-solid-svg-icons"

export const BrochureShortcut = () => {
    const [ showIcon, setShowIcon ] = useState(false)
    return (
        <a href='./pdf' download='celeste-mall-brochure.pdf'>
        <BrochureShortcutWrapper onMouseEnter={() => setShowIcon(true)} onMouseLeave={() => setShowIcon(false)}>
            {
                showIcon ?
                    <FontAwesomeIcon icon={faDownload} size="3x" color='#6c533f' />
                : 
                <P>
                    Celeste Brochure
                </P>
            }
        </BrochureShortcutWrapper>
        </a>
    )
}